export const onlyNumber = (value: string) => {
	return isNaN(value as unknown as number) ? null : value;
};
